var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitterNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 100 95",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M78.7559 0H94.0898L60.5896 40.241L100 95H69.1373L44.9683 61.789L17.3133 95H1.97006L37.8019 51.9577L0 0H31.6368L53.4835 30.3562L78.7466 0H78.7559ZM73.3741 85.3538H81.8709L27.0245 9.13949H17.9066L73.3741 85.3538Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterNew);
export default __webpack_public_path__ + "static/media/twitter_new.1eafafd9.svg";
export { ForwardRef as ReactComponent };